<template>
    <div class="sub-system-search">
        <el-form class="sub-system-search-from" ref="form" :model="form" label-width="80px">
            <el-form-item label="活动名称">
                <el-input size="small" v-model="form.version" placeholder="SDK版本"></el-input>
            </el-form-item>
            <el-form-item label="活动名称">
                <el-input size="small" v-model="form.detail" placeholder="描述"></el-input>
            </el-form-item>
            <el-form-item label="活动名称">
                <el-button size="mini" type="success" icon="el-icon-plus" @click="onSubmit">添加版本</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

    export default {
        name       : 'sub-system-search',
        props: ['type'],
        data(){
            return {
                form : {
                    version: '',
                    detail: '',
                }

            }
        },
        components : {},
        computed: {
            ...mapState(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment','$route']),
        },

        created() {

        },

        methods: {
            ...mapActions(['ALERT_HANDLE']),
            ...mapActions('systemSdkVersion', ['ADD_BASE_VERSION']),

            onSubmit(){
                let reg = /^[0-9\.]{2,}$/;

                if(!this.$helper.helper.tirm(this.form.version)) {
                    this.ALERT_HANDLE({message: '版本号不能为空！例如: 5.2.0'});
                    return false;
                }

                if(!this.$helper.helper.tirm(this.form.detail)) {
                    this.ALERT_HANDLE({message: '版本描述不能为空！'});
                    return false;
                }

                if(!reg.test(this.form.version)){
                    this.ALERT_HANDLE({message: '版本号只能包含数字和点，例如: 5.2.0'});
                    return false;
                }

                this.ADD_BASE_VERSION({data: this.form, platform: this.type });
            },
        }
    };
</script>

<style type="scss" scoped>
    .sub-system-search-from {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        padding: 0;
    }

    .sub-system-search-from >>> label { display: none}

    .sub-system-search-from >>> .el-form-item__content { margin-left: 0px!important; margin-right: 15px;}

    .sub-system-search-from .el-form-item {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/system/search.vue